import { render, staticRenderFns } from "./performance-summary-realization.vue?vue&type=template&id=5ef49b52"
import script from "./performance-summary-realization.vue?vue&type=script&lang=js"
export * from "./performance-summary-realization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports